import {
  Component,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
  HostListener,
} from '@angular/core';
import { AlertService, UtilsService } from 'src/app/shared/services';
import { ViewModalComponent } from '../view-modal/view-modal.component';
import { UploadedFile } from 'src/app/employee/models';

declare var $: any;

@Component({
  selector: 'app-upload-doc',
  templateUrl: './upload-doc.component.html',
  styleUrls: ['./upload-doc.component.scss'],
  standalone: false,
})
export class UploadDocComponent implements OnChanges {
  @HostListener('window:popstate', ['$event'])
  onPopState(event: Event): void {
    this.closeModal();
  }

  @Output() showViewFile = new EventEmitter();
  @Output() getDownloadDocs = new EventEmitter();
  @Output() deleteFile = new EventEmitter();
  @Output() uploadFile = new EventEmitter();
  @Input() data: UploadedFile[] = [];
  @ViewChild(ViewModalComponent) viewModal?: ViewModalComponent;
  @ViewChild('fileInput', { static: false })
  fileInput!: ElementRef<HTMLInputElement>;

  @Input() showViewIcon: boolean = true;
  @Input() showDownloadIcon: boolean = true;
  @Input() showDeleteIcon: boolean = true;
  @Input() showSelectFileBar: boolean = true;
  @Input() modalId: string = '';
  @Input() header: string = 'Upload Document';
  @Input() infoText: string = '';
  @Input() infoTextStyling: InfoCustomStyling = {};

  public employeeId: any;
  public isUploading = false; // for disabling button
  public uniqueFileName: string = '';
  public showLoader: boolean = false; // for showing Loader
  public searchText: string = '';
  public showSearchText: boolean = true;
  displayAlert: boolean = false;
  public file: any;
  public columns: { data: string | null; label: string; width: number }[] = [
    { data: 'filename', label: 'File Name', width: 350 },
    { data: 'uploadedBy', label: 'Uploaded By', width: 170 },
    { data: 'updatedAt', label: 'Updated On', width: 150 },
    { data: null, label: 'Action', width: 150 },
  ];
  public name: string = '';
  isEmployeeExited: boolean = false;
  acceptedFormat: string = '';
  supportedExtensions: string[] = [];
  sizeErrorMessage: string = '';

  constructor(
    public alertService: AlertService,
    private utilsService: UtilsService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.modalId === 'vendorUploadModal') {
      this.acceptedFormat =
        'Accepted formats are .pdf, .doc, .docx, .jpg, .jpeg, .png';
      this.supportedExtensions = [
        '.pdf',
        '.doc',
        '.docx',
        '.jpg',
        '.jpeg',
        '.png',
      ];
    } else if (this.modalId === 'uploadLearningDevelopment') {
      this.acceptedFormat = 'Accepted formats are .pdf, .jpg, .jpeg, .png';
      this.supportedExtensions = ['.pdf', '.jpg', '.jpeg', '.png'];
    } else {
      this.acceptedFormat =
        'Accepted formats are .pdf, .doc, .docx, .txt, .pptx, .ppt';
      this.supportedExtensions = [
        '.pdf',
        '.doc',
        '.docx',
        '.txt',
        '.pptx',
        '.ppt',
      ];
    }
  }

  openModal(id: any, isEmployeeExited: boolean = false) {
    this.alertService.clear();
    this.employeeId = id;
    this.isEmployeeExited = isEmployeeExited;
    (<any>$('#uploadModalDialog')).modal('show');
    this.clearFile();
  }

  clearFile() {
    this.file = null;
    if (this.fileInput && this.fileInput.nativeElement.value) {
      this.fileInput.nativeElement.value = '';
    }
    this.isUploading = false;
  }

  viewFile(doc: any) {
    this.showViewFile.emit(doc);
  }

  closeModal() {
    (<any>$('#uploadModalDialog')).modal('hide');
    this.clearFile();
  }

  submitData() {
    if (this.isEmployeeExited) {
      this.alertService.error('No Active User.');
      return;
    }
    let formData = new FormData();
    this.isUploading = true;
    this.showLoader = true;
    formData.append('file', this.file);
    if (this.modalId !== 'uploadLearningDevelopment') {
      formData.append('empId', this.employeeId);
    }
    this.uploadFile.emit(formData);
  }

  updateFile(event: any) {
    this.file = event.target.files[0];
  }

  isSizeError() {
    let maxSize = 2048;
    if (this.modalId === 'vendorUploadModal') {
      maxSize = 10240;
      this.sizeErrorMessage = 'Max Size allowed is 10MB.';
    } else {
      this.sizeErrorMessage = ' Max size allowed is 2MB.';
    }
    const value = this.file && this.file.size / 1024 > maxSize;
    return value;
  }

  isFileExtensionNotSupported(): boolean {
    if (this.file) {
      const fileExtension = this.getFileExtension(this.file.name);
      return !this.supportedExtensions.includes(fileExtension);
    }
    return true;
  }

  getFileExtension(fileName: string): string {
    // Get the last index of the dot character to extract the file extension
    const dotIndex = fileName.lastIndexOf('.');
    if (dotIndex === -1) {
      return ''; // Return an empty string if no file extension found
    }
    return fileName.substring(dotIndex).toLowerCase();
  }

  downloadDocs(doc: any) {
    this.getDownloadDocs.emit(doc);
  }

  deleteFn(id: any) {
    this.uniqueFileName = id;
    (<any>$('#confirmDltModal')).modal('show');
  }

  fnDeleteFile() {
    this.showLoader = true;
    if (this.uniqueFileName) {
      this.deleteFile.emit(this.uniqueFileName);
    }
  }

  fnCloseConfirmDeleteModal() {
    (<any>$('#confirmDltModal')).modal('hide');
    this.clearFile();
  }

  getHalfLabel(value: string | Date | null | undefined, maxlength: number) {
    let label = '';
    if (value) {
      label = this.utilsService.getLabel(value, maxlength);
    } else {
      label = '';
    }
    return label;
  }

  getFormattedDate(value: string | Date | null | undefined) {
    let date: any = '';
    if (value) {
      date = this.utilsService.fnConvertDate(new Date(value));
    } else {
      date = '';
    }
    return date;
  }
}

interface InfoCustomStyling {
  infoTextWrapper?: {
    className: string;
    styling: { [key: string]: any };
  };
}
